import React, { useState } from "react";
import { Button } from "@/components/Button";
import { RadioButton, RadioCards } from "@/components/RadioCards";
import { useAccountContext } from "../../AccountContext";
import { useAddress, useSelectedItemContext } from "../../SelectedItemContext";
import { Address } from "../../types";
import { Home } from "@mui/icons-material";
import { DrawerPageProps } from "../types";
import { getRechargeShippingAddressLink } from "../../RechargeApiActions";

export type UpdateAddressPageProps = DrawerPageProps;

const UpdateAddressPage = ({ notify }: UpdateAddressPageProps) => {
  const addressesOriginal = useAccountContext().addresses;
  const currentAddress = useSelectedItemContext().boxItem.address;
  const addressMutator = useAddress();
  const [selectedShipAddressId, setSelectedShipAddressId] = useState(
    currentAddress.id
  );

  const addresses = [
    currentAddress,
    ...addressesOriginal.filter((address) => address.id !== currentAddress.id),
  ];

  const addressOptions: RadioButton<number>[] = addresses.map((address) => {
    return {
      value: address.id,
      label: (
        <>
          <div>
            <p className="title text-sm">
              {address.firstName}
              {address.lastName ? ` ${address.lastName}` : ""}
              {address.company ? `, ${address.company}` : ""}
            </p>
            <p className="body text-sm">{address.address1}</p>
            <p className="body text-sm">{address.address2}</p>
            <p className="body text-sm">
              {address.city}, {address.province} {address.zip}
            </p>
          </div>
          {address.id === currentAddress.id && (
            <div className="pointer-events-none absolute bottom-4 right-4">
              <Home
                className="mx-1 text-primary-200"
                style={{ fontSize: 20 }}
              />
            </div>
          )}
        </>
      ),
    };
  });

  const handleShipAddressChange = (value: number) => {
    if (value) {
      setSelectedShipAddressId(value);
    }
  };

  const handleShipAddressSubmit = () => {
    addressMutator.mutate(selectedShipAddressId, {
      onSuccess: () => {
        // confirmation message
        const { firstName, lastName, city, zip } = addresses.find(
          (address) => address.id === selectedShipAddressId
        ) as Address;
        notify({
          title: "Delivery Address Updated",
          message: `${firstName} ${lastName} in ${city} ${zip}`,
        });
      },
      onError: (e) => {
        notify({
          title: "Error",
          message: `An error occurred. Please try again.`,
          severity: "error",
        });
      },
    });
  };

  return (
    <>
      <RadioCards
        label="Change Shipping Address:"
        options={addressOptions}
        value={selectedShipAddressId}
        onChange={handleShipAddressChange}
      />
      <p className="body text-sm">
        To add a new address or remove any of the above, please visit the{" "}
        <a
          className="text-gray-700 underline hover:text-primary"
          href={getRechargeShippingAddressLink()}
        >
          Shipping Addresses
        </a>{" "}
        tab.
      </p>
      <Button
        className="w-full"
        disabled={currentAddress.id === selectedShipAddressId}
        onClick={handleShipAddressSubmit}
      >
        Update Address
      </Button>
    </>
  );
};

export { UpdateAddressPage };
